import {useMemo, useState} from 'react'
import {Box, Button, Flex, Text} from '@chakra-ui/react'
import ExamItem from '@pages/ExamPage/components/ExamItem'
import {uniqueId} from 'lodash'

const PER_PAGE = 6
const ListExam = ({data, setName, type}: any) => {
  const [page, setPage] = useState(1)

  const dataShow = useMemo(() => {
    if (data?.length > 0) {
      return data?.slice(0, page * PER_PAGE)
    }
    return []
  }, [page, data])

  return (
    <Flex flexDirection={'column'} w={'100%'}>
      {dataShow?.map((item: any, index: number) => (
        <ExamItem
          data={item}
          key={uniqueId(index.toString())}
          isLock={index > 2}
          type={type}
          setName={setName}
        />
      ))}
      {page * PER_PAGE < data?.length && (
        <Box marginTop={'24px'}>
          <Button
            px={'24px'}
            onClick={() => setPage(prevState => prevState + 1)}
            backgroundColor={'transparent'}>
            <Text
              color={'#1890FF'}
              fontSize={{base: 14, md: '16px'}}
              fontWeight={500}>
              Tải thêm...
            </Text>
          </Button>
        </Box>
      )}
    </Flex>
  )
}

export default ListExam
